// extracted by mini-css-extract-plugin
module.exports = {"events":"Events__events--127iO"};